import { transformRoutes } from '@backoffice-frontend/common'

export const relative = (route: string) => route.replace(/^\//, '')

export const BaseUserManagementAreaRoutes = {
  route: '/user-management',
  AllUsers: {
    route: '/all-users',
  },
  AdminPanel: {
    route: '/admin-panel',
    Users: {
      route: '/users',
    },
    AdminRoles: {
      route: '/roles',
    },
    Rights: {
      route: '/rights',
    },
  },
  Backoffice: {
    route: '/backoffice',
    Users: {
      route: '/users',
    },
    Groups: {
      route: '/groups',
    },
    Rights: {
      route: '/rights',
    },
  },
  User: {
    route: '/user',
    Show: {
      route: '/:id',
      History: {
        route: '/history',
      },
    },
  },
  Group: {
    route: '/group',
    Show: {
      route: '/:groupName',
      Rights: {
        route: '/rights',
      },
      Users: {
        route: '/users',
      },
      Approvers: {
        route: '/approvers',
      },
      History: {
        route: '/history',
      },
    },
  },
  History: {
    route: '/history',
  },
}

export const UserManagementAreaRoutes = transformRoutes(
  BaseUserManagementAreaRoutes,
)
